import React, { useEffect, createElement } from 'react';
// Declare fbq function for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export const initializePixel = () => {
  try {
    // Only run in browser environment
    if (typeof window === 'undefined') return;
    // If already initialized, don't do it again
    if (window.fbq) return;
    // Load Facebook Pixel script
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your pixel ID
    window.fbq('init', '1143276311082633');
    window.fbq('track', 'PageView');
  } catch (error) {
    // Log error but don't break the app
    console.error('Failed to initialize Meta Pixel:', error);
  }
};
export const PixelPageView = () => {
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'PageView');
      }
    } catch (error) {
      console.error('Failed to track page view:', error);
    }
  }, []);
  return null;
};
export const trackPurchaseClick = () => {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  } catch (error) {
    console.error('Failed to track purchase click:', error);
  }
};
export const trackLeadEvent = () => {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Lead');
    }
  } catch (error) {
    console.error('Failed to track lead event:', error);
  }
};